import { render, staticRenderFns } from "./MemberTags.vue?vue&type=template&id=7276d444&"
import script from "./MemberTags.vue?vue&type=script&lang=js&"
export * from "./MemberTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports